<template>
    <div class="col-md-3 col-sm-6 mb-sm-4 profile-block profile-block--stripchat" :class="{'isDefault': advert.isDefault}" :id="id">
        <span @click.prevent="advertClickUrl(advert, advert.isDefault ? '_self' : '_blank', 'native-strip-chat', impressionId)" class="profile-block-link h-100">
            <span class="profile-block-images loaded h-100">
                <div class="profile-block-images-new-banner stripchat-item-partner-tag" v-if="!advert.isDefault && advert.imageurl">Live cam</div>
                <div v-if="!advert.imageurl" class="stripchat-item-image"></div>
                <div v-else :style="{'background-image': `url('${advert.imageurl}')`}" class="stripchat-item-image" :class="{'stripchat-item-image--default': advert.isDefault}"></div>
            </span>
        </span>

        <span class="profile-block-details">
            <span class="user-details overflow-hidden">
                <span class="heading-1 d-flex">
                    <span class="text-ellipsis">
                        {{ advert.name }}
                    </span>
                </span>
                <span class="user-details-location">
                    <span class="text-ellipsis">
                        {{ advert.aboutme }}
                    </span>
                </span>
            </span>
        </span>
    </div>
</template>

<script>

import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import advertMixin from "@/components/mixins/adverts/advertMixin";
import {incrementNativeAdImpressionCount} from "@/core/utils/helpers/cookieHelper";
import {generateImpressionId} from "@/core/utils/helpers/advertHelper";

const data = () => {
    return {
        id: generateImpressionId(),
        impressionIds: [],
        impressionId: null,
    }
}

function created() {
    this.impressionId = generateImpressionId();
}
function observer() {
    if (this.hideExplicitRegionAds) {
        return;
    }

    const id = this.id;
    if (!id || typeof window === "undefined" ||  !_.get(this,'advert.imageurl', _.get(this, 'advert.image_full_link'))) {
        return;
    }
    const advertisement = document.getElementById(id);
    if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!this.impressionIds.includes(id)) {
                        const nativeImpressionCount = incrementNativeAdImpressionCount();
                        this.captureTrackingEvent(this.currentUser, 'search', 'native-ads-impression', 'native-strip-chat', null, {
                            position: this.advert.position,
                            sch: this.advert.searchId,
                            'native_impression_count': nativeImpressionCount,
                            'impression_id': this.impressionId,
                        })
                        this.impressionIds.push(id);
                    }
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.5
        });
        observer.observe(advertisement);
    }
}

export default {
    created,
    data,
    computed: {
        ...mapState(['currentUser', 'hideExplicitRegionAds']),
    },
    mixins: [xtrackingMixin, advertMixin],
    props: {
        advert: {
            required: true,
        }
    },
    methods:{
        observer,
    },
    watch: {
        advert: {
            deep: true,
            handler() {
                this.observer()
            }
        },
    },
}
</script>
